module.exports = __webpack_public_path__ + "img/icon_record.13e9b9a.svg";